import React from 'react';
import { Check } from 'lucide-react';

const steps = [
  { number: 1, title: 'Datos del Veterinario' },
  { number: 2, title: 'Datos del Paciente' },
  { number: 3, title: 'Pruebas y Observaciones' },
  { number: 4, title: 'Información Clínica' },
  { number: 5, title: 'Recolección de Muestras' },
];

export default function FormStepper({ currentStep }) {
  return (
    <div className="bg-white border-b border-slate-200 py-6">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <React.Fragment key={step.number}>
              <div className="flex flex-col items-center flex-1">
                <div
                  data-testid={`step-${step.number}`}
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-all ${
                    currentStep > step.number
                      ? 'bg-primary-amplicare text-white'
                      : currentStep === step.number
                      ? 'bg-primary-amplicare text-white ring-4 ring-primary-amplicare ring-opacity-20'
                      : 'bg-slate-100 text-slate-400'
                  }`}
                >
                  {currentStep > step.number ? (
                    <Check className="w-5 h-5" />
                  ) : (
                    step.number
                  )}
                </div>
                <span
                  className={`text-xs mt-2 text-center hidden sm:block ${
                    currentStep >= step.number
                      ? 'text-slate-700 font-medium'
                      : 'text-slate-400'
                  }`}
                >
                  {step.title}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`flex-1 h-0.5 mx-2 transition-all ${
                    currentStep > step.number
                      ? 'bg-primary-amplicare'
                      : 'bg-slate-200'
                  }`}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}